module.exports = __webpack_public_path__ + "img/P150T_weapon_37.dfd116ac.png";